// import * as XLSX from "xlsx-js-style";

// export const sprintExcel = (data, filters = {}) => {
//   if (!Array.isArray(data) || data.length === 0) return;

//   const worksheet = XLSX.utils.aoa_to_sheet([]);

//   /* ================= HEADER ================= */
//   const headerInfo = [
//     ["Sprint"]
//   ];

//   XLSX.utils.sheet_add_aoa(worksheet, headerInfo, { origin: "A1" });

//   const reportHeaderStyle = {
//     font: { bold: true, sz: 16 },
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "BDD7EE" } }
//   };

//   if (worksheet["A1"]) worksheet["A1"].s = reportHeaderStyle;

//   worksheet["!merges"] = [
//     { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } } // merge A1:I1
//   ];




  

//   /* ================= DATA ================= */
//   const excelData = data.map(row => ({
//     SLNO: row.SLNO,
//     "Scheduled To": row.EmployeeName,
//     Task: row.Task,
//     "PP Date": row.ProjectPlanDate,
//     Effort: row.Effort,
//     "Scheduled Date": row.ScheduledDate,
//     "Comp Date": row.CompletedDate || "-",
//     Comments: row.Comments || "",
//     Status: row.Status
//   }));

//   // Start table from row 9 (A9)
//   XLSX.utils.sheet_add_json(worksheet, excelData, { origin: "A9" });

//   /* ================= STYLES ================= */
//   const range = XLSX.utils.decode_range(worksheet["!ref"]);

//   const tableHeaderStyle = {
//     font: { bold: true },
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "D9D9D9" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   const oddRowStyle = {
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "FFFFFF" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   const evenRowStyle = {
//     alignment: { horizontal: "center", vertical: "center" },
//     fill: { fgColor: { rgb: "EEF3FB" } },
//     border: {
//       top: { style: "thin" },
//       bottom: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" }
//     }
//   };

//   /* Table Header Row (Row 7 → index 6) */
//   for (let C = range.s.c; C <= range.e.c; C++) {
//     const cell = XLSX.utils.encode_cell({ r: 6, c: C });
//     if (worksheet[cell]) worksheet[cell].s = tableHeaderStyle;
//   }

//   /* Table Body Zebra Styling */
//   for (let R = 8; R <= range.e.r; R++) {
//     const rowStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

//     for (let C = range.s.c; C <= range.e.c; C++) {
//       const cell = XLSX.utils.encode_cell({ r: R, c: C });
//       if (worksheet[cell]) worksheet[cell].s = rowStyle;
//     }
//   }

//   /* ================= ALIGN TEXT COLUMNS ================= */
//   const leftAlignCols = [1, 2, 9]; // Scheduled To, Task, Comments

//   for (let R = 8; R <= range.e.r; R++) {
//     leftAlignCols.forEach(C => {
//       const cell = XLSX.utils.encode_cell({ r: R, c: C });
//       if (worksheet[cell]) {
//         worksheet[cell].s.alignment = {
//           horizontal: "center",
//           vertical: "center",
//           wrapText: true
//         };
//       }
//     });
//   }

//   /* ================= COLUMN WIDTH ================= */
//   worksheet["!cols"] = [
//     { wch: 6 },   // SLNO
//     { wch: 22 },  // Scheduled To
//     { wch: 30 },  // Task
//     { wch: 14 },  // PP Date
//     { wch: 10 },  // Effort
//     { wch: 16 },  // Scheduled Date
//     { wch: 16 },  // Comp Date
//     { wch: 30 },  // Comments
//     { wch: 14 }   // Status
//   ];

//   /* ================= WORKBOOK ================= */
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Sprint");

//   XLSX.writeFile(workbook, "Sprint.xlsx");
// };

// export default sprintExcel;



import * as XLSX from "xlsx-js-style";

export const sprintExcel = (data, filters = {}) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const ws = XLSX.utils.aoa_to_sheet([]);

  /* ================= TITLE ================= */
  XLSX.utils.sheet_add_aoa(ws, [["Sprint"]], { origin: "A1" });

  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  // Merge A1 → I1
  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }];

  ws["!rows"] = [{ hpt: 28 }];

  /* ================= HEADER BLOCK ================= */
  const headerBlock = [
    ["Comp → Completed || PP → Project Plan", "", "", "", "", "", "", ""],

    ["Code:", filters.Code || "", "", "", "Description:", filters.Description || "", "", ""],

    ["From Date:", filters.FromDate || "", "", "", "To Date:", filters.ToDate || "", "", ""],

    ["Milestone:", filters.Milestone || "", "", "", "Stages:", filters.Stages || "", "", ""],

    ["Activities:", filters.Activities || "", "", "", "", "", "", ""],
  ];

  // Insert header block from B3
  XLSX.utils.sheet_add_aoa(ws, headerBlock, { origin: "B3" });

  /* ================= HEADER MERGES ================= */
  ws["!merges"].push(
    // Header title
    { s: { r: 2, c: 1 }, e: { r: 2, c: 8 } },

    // Code value
    { s: { r: 3, c: 2 }, e: { r: 3, c: 4 } },

    // Description value
    { s: { r: 3, c: 6 }, e: { r: 3, c: 8 } },

    // From Date value
    { s: { r: 4, c: 2 }, e: { r: 4, c: 4 } },

    // To Date value
    { s: { r: 4, c: 6 }, e: { r: 4, c: 8 } },

    // Milestone value
    { s: { r: 5, c: 2 }, e: { r: 5, c: 4 } },

    // Stages value
    { s: { r: 5, c: 6 }, e: { r: 5, c: 8 } },

    // Activities full width
    { s: { r: 6, c: 2 }, e: { r: 6, c: 8 } }
  );

  /* ================= HEADER BLOCK STYLE ================= */
  const headerStyle = {
    font: { bold: true },
    // alignment: { vertical: "center" }
  };

  // Apply bold to B3 → I7
  for (let R = 2; R <= 6; R++) {
    for (let C = 1; C <= 8; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (ws[cell]) {
        ws[cell].s = { ...headerStyle };
      }
    }
  }

  // Center main header text
  ws["B3"].s = {
    font: { bold: true },
    // alignment: { horizontal: "center", vertical: "center" }
  };

  /* ================= TABLE DATA ================= */
  const tableData = data.map(row => ({
    "SL.No": row.SLNO,
    "Scheduled To": row.EmployeeName,
    Task: row.Task,
    "PP Date": row.ProjectPlanDate,
    Effort: row.Effort,
    "Scheduled Date": row.ScheduledDate,
    "Comp Date": row.CompletedDate || "--",
    Comments: row.Comments || "",
    Status: row.Status
  }));

  XLSX.utils.sheet_add_json(ws, tableData, { origin: "A9" });

  const range = XLSX.utils.decode_range(ws["!ref"]);

  /* ================= TABLE HEADER STYLE ================= */
  const tableHeaderStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  for (let C = 0; C <= 8; C++) {
    const cell = XLSX.utils.encode_cell({ r: 8, c: C });
    if (ws[cell]) ws[cell].s = tableHeaderStyle;
  }

  /* ================= ROW STYLES ================= */
  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const centerCols = [0, 1, 4, 8];

  for (let R = 9; R <= range.e.r; R++) {
    const base = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C <= 8; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...base,
        alignment: {
          horizontal: centerCols.includes(C) ? "center" : "left",
          vertical: "center",
          wrapText: true
        }
      };
    }
  }

  /* ================= COLUMN WIDTH ================= */
  ws["!cols"] = [
    { wch: 6 },
    { wch: 22 },
    { wch: 35 },
    { wch: 14 },
    { wch: 10 },
    { wch: 16 },
    { wch: 16 },
    { wch: 30 },
    { wch: 14 }
  ];

  /* ================= EXPORT ================= */
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sprint");
  XLSX.writeFile(wb, "Sprint.xlsx");
};

export default sprintExcel;



